const {
  canUseDOM,
  loadConfigSSR,
  loadConfigBrowserSync
} = require('./config-loader')

// SSR (Node.js): Load config synchronously before requiring index
if (!canUseDOM) {
  if (process.env.NODE_ENV === 'production') {
    loadConfigSSR()
  }
  module.exports = require('./index')
} else {
  // Browser: Load config synchronously from CDN before requiring index
  loadConfigBrowserSync()
  module.exports = require('./index')
}
